import { Theme } from "@amx/ux-twoui-theming";
import { twouiZIndexes } from "@amx/ux-twoui-utils";
import { IStackStyles } from "@fluentui/react";
import { INavStyleProps, INavStyles } from "@m365-admin/nav";
import { ViewportType } from "../../shared/constants";
import { boxShadowDepths } from "../../styles/constants";
import { isExtraLargeOrBiggerViewport, isSmallToLargeViewport, isSmallViewport } from "./LeftNav";

export const navWrapperStyle = (isNavCollapsed: boolean, viewportType: ViewportType): React.CSSProperties => {
    return {
        position: "fixed", // for page content to not move when expanding/collapsing the Left Nav
        height: isSmallViewport(viewportType) && isNavCollapsed ? "auto" : "100%",
        zIndex: twouiZIndexes.twoUINavBar // for Left Nav to expand above page content
    };
};

const navWidthCollapsed = 48;
const navWidthExpanded = 233;

export const navWrapperPaddingStyles = (viewportType: ViewportType): IStackStyles => {
    return {
        root: {
            // padding is to be occupied in lieu of the Left Nav because the wrapper sets the position as fixed.
            paddingRight: isSmallToLargeViewport(viewportType) ? `${navWidthCollapsed}px` : `${navWidthExpanded}px`
        }
    };
};

export const getNavStyles = (props: INavStyleProps, theme: Theme, viewportType: ViewportType, removeNavButtonBorder: boolean): Partial<INavStyles> => {
    const width = props.isNavCollapsed ? navWidthCollapsed : navWidthExpanded;
    const scrollBarMaxWidth = 17;

    return {
        root: {
            boxShadow: props.isNavCollapsed || isExtraLargeOrBiggerViewport(viewportType) ? undefined : boxShadowDepths.hover,
            height: "100%",
        },
        navContainer: {
            maxWidth: width + scrollBarMaxWidth,
            paddingRight: props.isNavCollapsed ? "3px" : undefined
        },
        navGroup: {
            display: props.isNavCollapsed && isSmallViewport(viewportType) ? "none" : undefined
        },
        subComponentStyles: {
            collapseNavButtonStyles: {
                root: {
                    backgroundColor: theme.palette.white,
                    borderBottom: removeNavButtonBorder ? undefined : `1px solid ${theme.palette.neutralLighter}`,
                    ":hover": {
                        backgroundColor: theme.palette.neutralLighter
                    },
                    ":active": {
                        backgroundColor: theme.palette.neutralLight,
                        borderBottom: `1px solid ${theme.palette.neutralLight}`,
                    }
                },
                icon: {
                    color: theme.palette.themePrimary,
                    ":hover": {
                        color: theme.palette.themeDark
                    },
                    ":active": {
                        color: theme.palette.themeDark
                    }
                }
            }
        }
    };
};
